import React from 'react';
import { Block, FormBlockLabel as Label, FormTextInput as Input, FormSelect as Select, Heading, Paragraph } from '../../devlink/_Builtin';
import { MortgageFormData, PROPERTY_REGIONS, PRODUCT_TYPES, FORM_STEPS } from '../types/mortgage';

interface FormStep1Props {
  formData: Partial<MortgageFormData>;
  errors: Record<string, string>;
  updateFormData: (field: keyof MortgageFormData, value: any) => void;
}

const FormStep1: React.FC<FormStep1Props> = ({ formData, errors, updateFormData }) => {
  const stepInfo = FORM_STEPS[0];

  return (
    <Block>
      <div>
        <Heading tag="h2">{stepInfo.title}</Heading>
        <Paragraph>{stepInfo.description}</Paragraph>
      </div>

      <div>
        <div>
          <Label htmlFor="propertyRegion">
            Property Region *
          </Label>
          <Select
            value={formData.propertyRegion || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => updateFormData('propertyRegion', e.target.value)}
            options={[
              { v: '', t: 'Select a region' },
              ...PROPERTY_REGIONS.map(region => ({ v: region.value, t: region.label }))
            ]}
          />
          {errors.propertyRegion && (
            <span>{errors.propertyRegion}</span>
          )}
        </div>

        <div>
          <Label htmlFor="mortgageTermYears">
            Mortgage Term (Years) *
          </Label>
          <Input
            value={formData.mortgageTermYears?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('mortgageTermYears', Number(e.target.value))}
            type="number"
            placeholder="25"
          />
          {errors.mortgageTermYears && (
            <span>{errors.mortgageTermYears}</span>
          )}
        </div>

        <div>
          <Label htmlFor="mortgageTermMonths">
            Mortgage Term (Months) *
          </Label>
          <Input
            value={formData.mortgageTermMonths?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('mortgageTermMonths', Number(e.target.value))}
            type="number"
            placeholder="0"
          />
          {errors.mortgageTermMonths && (
            <span>{errors.mortgageTermMonths}</span>
          )}
        </div>

        <div>
          <Label htmlFor="interestRate">
            Interest Rate (%) *
          </Label>
          <Input
            value={formData.interestRate?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('interestRate', Number(e.target.value))}
            type="number"
            step="0.01"
            placeholder="3.5"
          />
          <small>Current promotional interest rate</small>
          {errors.interestRate && (
            <span>{errors.interestRate}</span>
          )}
        </div>

        <div>
          <Label htmlFor="revertRate">
            Revert Rate (%) *
          </Label>
          <Input
            value={formData.revertRate?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('revertRate', Number(e.target.value))}
            type="number"
            step="0.01"
            placeholder="5.5"
          />
          <small>Standard variable rate after promotional period</small>
          {errors.revertRate && (
            <span>{errors.revertRate}</span>
          )}
        </div>

        <div>
          <Label htmlFor="productType">
            Product Type *
          </Label>
          <Select
            value={formData.productType || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => updateFormData('productType', e.target.value)}
            options={[
              { v: '', t: 'Select a product type' },
              ...PRODUCT_TYPES.map(product => ({ v: product.value, t: product.label }))
            ]}
          />
          {errors.productType && (
            <span>{errors.productType}</span>
          )}
        </div>
      </div>
    </Block>
  );
};

export default FormStep1; 